// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountsPage_container__Ir4JI","iconButton":"DiscountsPage_iconButton__L9Btv","tableHeader":"DiscountsPage_tableHeader__2Ql3J"};